<template>
    <v-card class="onsite-today-table" ref="card">
        <v-container class="pa-xl-5" ref="container">
            <div class="header" ref="header">
                {{$vuetify.lang.t('$vuetify.onsiteTodayTable.onsiteStatus')}}
            </div>
            <v-simple-table
                v-if="onsites.length > 0"
                id="onsite-status-table"
                fixed-header
                :height="tableHeight">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">{{$vuetify.lang.t('$vuetify.onsiteTodayTable.name')}}</th>
                            <th class="text-left">{{$vuetify.lang.t('$vuetify.onsiteTodayTable.group')}}</th>
                            <th class="text-left">{{$vuetify.lang.t('$vuetify.onsiteTodayTable.submittedDate')}}</th>
                            <th class="text-left">{{$vuetify.lang.t('$vuetify.onsiteTodayTable.status')}}</th>
                            <th class="text-left">{{$vuetify.lang.t('$vuetify.onsiteTodayTable.period')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(onsite, index) in onsites"
                            :key="onsite.name + index"
                            >
                            <td>{{ onsite.name }}</td>
                            <td>{{ onsite.group }}</td>
                            <td>{{ onsite.date }}</td>
                            <td>
                                <div :class="statusStyle(onsite.status['key'])">
                                    <i class="onsite-icon mt-1 mr-1 fas fa-hard-hat"></i>
                                    {{ onsite.status['value'] }}
                                </div>
                            </td>
                            <td>{{ onsite.period }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <div v-else class="no-data" :style="{ height: tableHeight }">
                {{$vuetify.lang.t('$vuetify.onsiteTodayTable.onsiteStatusMessage')}}
            </div>
        </v-container>
    </v-card>
</template>

<script>

export default {
    name: 'OnsiteTodayTable',

    data () {
        return {
            branchId: null,
            tableHeight: '0px',
            onsites: []
        }
    },

    methods: {
        async loadData () {
            if (!this.branchId) {
                return
            }

            this.$store.dispatch('setLoading', true)
            let date = new Date()
            date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

            const res = await this.axios.get(
                `leave-or-onsite/onsite-table?branch=${this.branchId}&date=${date}`
            )

            if (res && res.data && res.data.status === 'ok') {
                this.onsites = res.data.data
            }

            this.setTableHeight()
            this.$store.dispatch('setLoading', false)
        },

        setTableHeight () {
            const containerStyle = window.getComputedStyle(this.$refs.container, null)
            this.tableHeight = `${this.$refs.card.$el.offsetHeight - (
                parseFloat(containerStyle.getPropertyValue('padding-top').substr(0, 2)) +
                parseFloat(containerStyle.getPropertyValue('padding-bottom').substr(0, 2)) +
                this.$refs.header.offsetHeight
            )}px`
        },

        statusStyle (status) {
            let base = 'status-box'
            if (status === 'APV') {
                base = `${base} approve`
            } else if (status === 'REJ') {
                base = `${base} reject`
            } else if (status === 'PND') {
                base = `${base} pending`
            }

            return base
        }
    },

    async mounted () {
        this.branchId = localStorage.getItem('currentBranchId')
        await this.loadData()
    },

    watch: {
        '$store.state.currentBranchId': async function (newValue) {
            if (newValue) {
                this.branchId = newValue
                await this.loadData()
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.loadData()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.onsite-today-table {
    height: 100%;
    border-radius: 15px !important;
    box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06) !important;

    .header {
        font-size: 20px !important;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
    }

    .status-box {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        padding: 12px;
        max-width: 120px;
        max-height: 36px;
        color: white;

        &.approve {
            background-color: #cca972;
        }

        &.reject {
            background-color: #ff544a;
        }

        &.pending {
            background-color: #6c6c6c;
        }
    }

    .icon {
        width: 14px;
        height: 14px;
        margin-right: 5px;
    }

    .no-data {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 40px;
        font-size: 22px;
        font-weight: 500;
        color: #6c6c6c;
    }

}
.onsite-icon {
    font-size: 12px;
}
::v-deep #onsite-status-table .v-data-table__wrapper {
    overflow-y: scroll;
}

::v-deep #onsite-status-table .v-data-table__wrapper::-webkit-scrollbar {
    width: 6px;
    background-color: #FFFFFF;
}

::v-deep #onsite-status-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #e5e5e5;
}

::v-deep #onsite-status-table .v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #FFFFFF;
}
</style>
